import { render, staticRenderFns } from "./AuthorCard.vue?vue&type=template&id=16a7a77c&scoped=true&"
import script from "./AuthorCard.vue?vue&type=script&lang=js&"
export * from "./AuthorCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16a7a77c",
  null
  
)

export default component.exports